import request from "../request";
import sysrequest from "../sysrequest";

const api = {
  searchAnnouncement(data) {
    const obj = {
      url: "/bid/demo_v1/announcements/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    return request(obj);
  },

  addAnnouncement(data) {
    const obj = {
      url: "/bid/demo_v1/announcements/add/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    return request(obj);
  },

  updateAnnouncement(data) {
    const obj = {
      url: "/bid/demo_v1/announcements/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    return request(obj);
  },

  deleteAnnouncement(data) {
    const obj = {
      url: "/bid/demo_v1/announcements/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    return request(obj);
  },
};
export default api;
